import { useEffect } from 'react';

import { type BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { mainSubject } from './subjects';

// This function is used to publish data to the Subject via next().
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const publish: (topic: string, data?: any) => void = (topic, data) => {
    mainSubject.next({ topic, data });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const publishBehaviorSubject = (subject: any, data: unknown) => {
    subject.next(data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useBehaviorSubject = (subject: BehaviorSubject<any>, callback: (d: any) => void) => {
    useEffect(() => {
        const subscription = subject.subscribe(callback);
        return () => subscription.unsubscribe();
    }, [subject, callback]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const listen = (topic: string, callback: (...args: any[]) => void) =>
    mainSubject
        .pipe(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            filter((f: any) => f.topic === topic),
            map((d) => d.data),
        )
        .subscribe(callback);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTopic = (topic: string, callback: (d: any) => void) => {
    useEffect(() => {
        const subscription = listen(topic, callback);

        return () => subscription.unsubscribe();
    }, [topic, callback]);
};
